import { Component, OnInit,Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse } from '@angular/common/http';
import { Router} from '@angular/router';
import { MatDialogRef,MAT_DIALOG_DATA } from '@angular/material/dialog';
import { KitchenStockPurchaseService } from '../../../shared/services/kitchen-stock-purchase.service';
import { AuthService } from '../../../shared/services/auth.service';


@Component({
  selector: 'ngx-add-stock-items',
  templateUrl: './add-stock-items.component.html',
  styleUrls: ['./add-stock-items.component.scss']
})
export class AddStockItemsComponent implements OnInit {

  itemDetails: any;
  addItemForm: FormGroup;
  showProcessingIndicator = false;
  showCheckQtyMessage = false;

  validationMessages:any = {
    'qty': { 'required': 'This field is required' },
  };

  formErrors:any = { 
    'qty': "",
  };


  constructor(
              @Inject(MAT_DIALOG_DATA) public data:any,
              public dialogRef: MatDialogRef<AddStockItemsComponent>,
              private kitchenStockPurchaseService : KitchenStockPurchaseService,
              private authService: AuthService,
              private fb: FormBuilder,
              private toastr: ToastrService,
              private router : Router, 
            ) { }

  ngOnInit(): void {
    this.itemDetails =  this.data;
    this.initializeForm();
    

    this.addItemForm.valueChanges.subscribe((data) => {
      this.logValidationErrors(this.addItemForm);
      });

  

  } //nd oninit


  initializeForm(){
    this.addItemForm = this.fb.group({  
      id:  [this.itemDetails.Id, Validators.required], 
      qtyInStock : [this.itemDetails.QtyBal], 
      qty :  ['', Validators.required],  
      amount :  [''], 
     
   
    });

  }

  
  onClose(){
    this.addItemForm.reset();
    this.dialogRef.close();
   }

   mapFormValuesToModel(){
    const formData = {
      ...this.addItemForm.value,
      createdBy:this.authService.getUserLoggedIn()
    }
    return formData;
   }

   addStockButtonClick(): void {
    this.logValidationErrors(this.addItemForm,true);
    var data = this.mapFormValuesToModel();

    if(this.addItemForm.valid){
        this.showProcessingIndicator = true;
          this.kitchenStockPurchaseService.create(data)
          .subscribe(
            (res) =>{
              this.toastr.success('Stock added successfully','Success');
              this.showProcessingIndicator = false;   
              this.onClose();
            },
            (err) =>{
              this.toastr.error('Failed to add stock','Failure'); 
              this.showProcessingIndicator = false;  
              if(err instanceof HttpErrorResponse){                 
                if(err.status == 401){
                  this.router.navigate(['/login']);
                }
              }
              console.log(err); 
            }
          )
        } 

    else{
          this.toastr.warning('Required Fields cannot be empty or invalid.','Error Message');
          this.showProcessingIndicator = false;                                                                                                                                                                                                   
        } 
   }



  isNumeric(value:any){
    if(!isNaN(value) &&  !isNaN(parseFloat(value))){
      return true;
    } 
     return false;
  
  }



   enableForm():void{
    Object.keys(this.addItemForm.controls).forEach(key => {
      this.addItemForm.controls[key].enable();
      //console.log("Enable "+key)     
    });

  }

   logValidationErrors(group: FormGroup = this.addItemForm,isDirty :boolean=false): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if(isDirty)
      {
        this.enableForm();
        this.addItemForm.controls[key].markAsTouched();
      }
        if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }

      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } 
    });
  }

  


}
